import {ExtendsProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {getNextWorkingDay} from '@/features/projects/utils'
import {zodResolver} from '@hookform/resolvers/zod'
import dayjs from 'dayjs'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const ExtendsCycleProjectFormProvider = ({
    children,
    project
}: {
    children: ReactNode
    project: ProjectExtended
}) => {
    const startDate = getNextWorkingDay(dayjs(project.expirationDate).toDate())
    const expirationDate =
        startDate && project.durationDays ? dayjs(startDate).add(project.durationDays, 'day').toDate() : undefined

    const form = useForm({
        mode: 'onBlur',
        resolver: zodResolver(ExtendsProjectFormValidationSchema),
        defaultValues: {
            id: project.id,
            patient: {
                id: project.patient?.id,
                fullName: project.patient?.fullName,
                serviceType: project.patient?.serviceType
            },
            siarProject: 'same_as_previous',
            referringProject: project,
            sector: project.sector,
            assistiveRegime: project.assistiveRegime || undefined,
            startDate: startDate,
            expirationDate: expirationDate,
            durationDays: project.durationDays ? project.durationDays : undefined,
            sender: project.sender || undefined,
            specialist: project.specialist || undefined,
            hasReopening: false
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
